'use strict';

module.exports = function whereBetween(key, values) {
  return this.where(key, '>=', values[0]).where(key, '<=', values[values.length - 1]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/whereBetween.js
// module id = ./node_modules/collect.js/dist/methods/whereBetween.js
// module chunks = 0